/**
 * Дисциплина → Tailwind-класс точки (canon-session 2026-07-24).
 * Статические строки — Tailwind не поддерживает динамические `bg-disc-${k}`
 * (purge их не увидит). Токены disc-* var-driven (tailwind.config → index.css, блок зон).
 */
export type DisciplineKey =
  | "run"
  | "bike"
  | "swim"
  | "strength"
  | "gravel"
  | "hyrox"
  | "duathlon"
  | "triathlon"
  | "trail";

export const DISC_DOT_BG: Record<DisciplineKey, string> = {
  run: "bg-disc-run",
  bike: "bg-disc-bike",
  swim: "bg-disc-swim",
  strength: "bg-disc-strength",
  gravel: "bg-disc-gravel",
  hyrox: "bg-disc-hyrox",
  duathlon: "bg-disc-duathlon",
  triathlon: "bg-disc-tri",
  trail: "bg-disc-trail",
};
